import { FilesPreview, PreviewFile } from '@billy/design-system'
import React, { ReactElement, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getImageClassName } from '../../../utils/getClassName'
import * as Styled from './styles'

interface FilesProps {
  files: PreviewFile[]
  isLoading: boolean
}

export const Files = ({ files, isLoading }: FilesProps): ReactElement | null => {
  const { t } = useTranslation()
  const [isError, setIsError] = useState(false)

  const handleError = useCallback(() => {
    setIsError(true)
  }, [])

  if (isLoading) {
    return null
  }

  if (!files.length) {
    return (
      <Styled.FileWrapper fullHeight>
        <Styled.FileMock>{t('no_files_attached')}</Styled.FileMock>
      </Styled.FileWrapper>
    )
  }

  return (
    <Styled.FileWrapper isError={isError}>
      <FilesPreview
        className={getImageClassName()}
        files={files}
        fitToHeight
        isFloatingActionsView
        loading=""
        onError={handleError}
        withDownloadButton
        withFilename
        withRotate
        zoomable
      />
    </Styled.FileWrapper>
  )
}
